import { mix } from '@immutabl3/utils';
import Signal from 'signal-js';
import { scrollTo, jumpTo } from './scroller.js';
import sensor from './sensor.js';
import data from './data.js';
import gate from './gate.js';

let paused = false;

const signal = Signal();

const window = globalThis;

const resizeMeasure = function() {
  const w = window.innerWidth ?? 0;
  const h = window.innerHeight ?? 0;
  
  const changed = w !== data.width || h !== data.height;
  
  data.width = w;
  data.height = h;

  changed && signal.emit('resize', data);
};

const scrollMeasure = function() {
  const top = sensor?.scrollTop ?? 0;
  data.top = gate.top !== -1
    ? Math.min(top, gate.top)
    : top;

  if (gate.top !== -1 && sensor) sensor.scrollTop = data.top;

  const left = sensor?.scrollLeft ?? 0;
  data.left = gate.left !== -1
    ? Math.min(left, gate.left)
    : left;
  
  if (gate.left !== -1 && sensor) sensor.scrollLeft = data.left;
};

const measure = function() {
  resizeMeasure();
  if (paused) return;
  scrollMeasure();
};

measure();

const win = mix(signal, {
  measure,

  get data() {
    return data;
  },

  pause() {
    paused = true;
    sensor?.pause?.();
    return this;
  },
  resume() {
    paused = false;
    sensor?.resume?.();
    return this;
  },

  gate({
    top = -1,
    left = -1,
  } = {}) {
    gate.top = top;
    gate.left = left;
    return this;
  },
  ungate() {
    gate.top = -1;
    gate.left = -1;
    return this;
  },

  scrollTop: () => data.top,
  scrollLeft: () => data.left,
  width: () => data.width,
  height: () => data.height,

  scrollTo,
  jumpTo({
    left = 0,
    top = 0,
  } = {}) {
    this.set('scrollLeft', left);
    this.set('scrollTop', top);
  },

  set(key, value) {
    sensor[key] = value;
    return this;
  },
  options(config = {}) {
    sensor.options(config);
    return this;
  },
});

export default win;